import styled from 'styled-components';

interface ReportMustHaveFilterValueProps {
  hasSecondColumn: boolean;
}

const ReportMustHaveFilterValue = styled.div<ReportMustHaveFilterValueProps>`
  display: grid;
  grid-template-columns: ${(props): string =>
    props.hasSecondColumn ? '1fr auto 1fr' : '1fr'};
  grid-column-gap: ${(props): string => props.theme.spaces.xl};
  background-color: none;
  align-items: center;
`;

export { ReportMustHaveFilterValue };
